<template>

  <div class="navbar-shadow" v-if="!isHomePage" ></div>

  
</template>

<script>

export default {
  data() {
    return {
      isHomePage: false,
    };
  },
  watch: {
    $route(to) {
      this.isHomePage = to.path === '/';
    },
  },
  mounted() {
    this.isHomePage = this.$route.path === '/';
  },
};
</script>

<style scoped>

.navbar-shadow {
  height: 88px; 
  background-color:transparent;
}

@media (min-width: 1090px) and (max-width: 1260px) { /* 810px to 1000px */
  
  .navbar-shadow {
    height: 3.5rem; /* 56px */
  }
}

@media (max-width: 1089px) { /* 809px */

  .navbar-shadow {
    height: 3rem; /* 48px */
  }

}
</style>